import React, { useState, useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';

// Components
import Header from './components/Header';
import Hero from './components/Hero';
import CollectionShowcase from './components/CollectionShowcase';
import ChakraSection from './components/ChakraSection';
import AstrologySection from './components/AstrologySection';
import SEOContentSection from './components/SEOContentSection';
import WebinarPromoSection from './components/WebinarPromoSection';
import Testimonials from './components/Testimonials';
import Newsletter from './components/Newsletter';
import QuickCrystalQuiz from './components/QuickCrystalQuiz';
import CrystalBall from './components/CrystalWheel';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Conversion & Engagement Widgets
import BuyerNotifications from './components/BuyerNotifications';
import CosmicSidebar from './components/CosmicSidebar';

// Pages
import MetaphysicalHubPage from './pages/MetaphysicalHubPage';
import ChakrasPage from './pages/ChakrasPage';
import AboutPage from './pages/AboutPage';
import KholeyPage from './pages/KholeyPage';
import WebinarRegistrationPage from './pages/WebinarRegistrationPage';
import EducationPage from './pages/EducationPage';
import ExclusiveCollectionPage from './pages/ExclusiveCollectionPage';
import BookPage from './pages/BookPage';
import RomonaPage from './pages/RomonaPage';
import BackorderPage from './pages/BackorderPage';
import ShopPage from './pages/ShopPage';
import DirectoryPage from './pages/DirectoryPage';
import HealingPrescriptionPage from './pages/HealingPrescriptionPage';
import FifaRootPage from './pages/FifaRootPage';
import { usePageTitle } from './hooks/usePageTitle';

// Home Page Component
const HomePage = () => {
  usePageTitle(null);
  return (
    <>
      <Hero />
      <QuickCrystalQuiz />
      <CollectionShowcase />
      <CrystalBall />
      <ChakraSection />
      <AstrologySection />
      <WebinarPromoSection />
      <SEOContentSection />
      <Testimonials />
      <Newsletter />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster 
          position="top-right" 
          richColors 
          toastOptions={{
            style: {
              background: '#faf8f5',
              border: '1px solid #e8e4de',
              fontFamily: 'Montserrat, sans-serif',
            },
          }}
        />
        <Header />
        
        {/* Global Engagement Widgets */}
        <BuyerNotifications />
        <CosmicSidebar />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hub" element={<MetaphysicalHubPage />} />
          <Route path="/chakras" element={<ChakrasPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/education" element={<EducationPage />} />
          <Route path="/kholey" element={<KholeyPage />} />
          <Route path="/romona-nicole-schmidt-gemstone-healing-expert" element={<RomonaPage />} />
          <Route path="/webinar-registration" element={<WebinarRegistrationPage />} />
          <Route path="/collection" element={<ExclusiveCollectionPage />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/healing-prescription" element={<HealingPrescriptionPage />} />
          <Route path="/root-for-your-team" element={<FifaRootPage />} />
          <Route path="/book" element={<BookPage />} />
          {/* Shop with placeholder crystals + sacred collection + vendor form */}
          <Route path="/shop" element={<ShopPage />} />
          {/* Catch old product URLs for SEO */}
          <Route path="/shop/:slug" element={<BackorderPage />} />
          <Route path="/product/:slug" element={<BackorderPage />} />
          <Route path="*" element={<BackorderPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
